import React, { useRef, useState, useEffect } from "react";
import { Button } from "../../../../shadcn/components/ui/button";
import HomeIconSvg from "../../../../icons/HomeIconSvg";
import { PostPropertyCard } from "../../../../shadcn/components/custom/PostPropertyCard";
import { useSelector } from "react-redux";
import { AuthModalWrapper } from "../../Auth/AuthModal";

export default function PostYourProperty() {
  const isLoggedIn = useSelector((state: any) => state.auth.user);
  const [modalOpen, setModalOpen] = useState(false);
  const handlePostYourPropertyClick = () => {
    if (isLoggedIn) window.open(`/post-your-property`, "_blank");
    else setModalOpen(true);
  };

  return (
    <>
      {process.env.NEXT_PUBLIC_PYP_ENABLE === "true" ? (
        <>
          {" "}
          {/* Post your Property */}
          <div className="hidden lg:flex mt-20 bg-brand-lightBlue ">
            <div className="w-full px-customPadding  2xl:w-[1340px] 2xl:px-0 2xl:mx-auto flex">
              {/* Left part */}
              <div className="pt-[112px] pb-[49px]">
                {" "}
                <div className="">
                  <HomeIconSvg height="44px" width="44px">
                    {" "}
                  </HomeIconSvg>
                </div>
                <p className="font-spaceGrotesk font-normal text-web-h2 leading-[57px] text-brand-textBlack max-w-[583px] mt-[22px]">
                  DO YOU HAVE A PROPERTY TO OFFER ?
                </p>
                <Button
                  onClick={handlePostYourPropertyClick}
                  className="h-[60px] w-[233px] mt-[67px]"
                >
                  <p className="font-openSans font-semibold text-[22px] leading-[30px] text-white">
                    Post your property
                  </p>
                </Button>
              </div>
              {/* Right part */}
              <PostPropertyCard className="bg-white w-[650px] mt-[62px] pt-[77px] pl-[60px] pr-[100px]  ml-auto clip-path-bottomRightPostProperty" />
            </div>
          </div>{" "}
          <AuthModalWrapper
            userLoggedin={isLoggedIn}
            authModelOpen={modalOpen}
            setAuthModelOpen={setModalOpen}
          />
        </>
      ) : (
        <></>
      )}
    </>
  );
}
